import { IBookStrategy } from '@aca-new/app/pages/book/shared/models/interfaces/book-strategy.interface';
import { AuditsBookStrategyService } from '@aca-new/app/pages/book/shared/services/book-strategy/audits/audits-book-strategy.service';
import { FoodCertificationBookStrategyService } from '@aca-new/app/pages/book/shared/services/book-strategy/food-certification/food-certification-book-strategy.service';
import { InspectionBookStrategyService } from '@aca-new/app/pages/book/shared/services/book-strategy/inspection/inspection-book-strategy.service';
import { LabTestingBookStrategyService } from '@aca-new/app/pages/book/shared/services/book-strategy/lab-testing/lab-testing-book-strategy.service';
import { EBusinessSolution } from '@aca-new/app/shared/models/enums/business-solution.enum';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BookStrategyFactoryService {
  public constructor(
    private readonly _auditsBookStrategyService: AuditsBookStrategyService,
    private readonly _labTestingBookStrategyService: LabTestingBookStrategyService,
    private readonly _inspectionBookStrategyService: InspectionBookStrategyService,
    private readonly _foodCertificationBookStrategyService: FoodCertificationBookStrategyService
  ) {}

  public getCurrentStrategyService(businessSolution: string): IBookStrategy {
    switch (businessSolution) {
      case EBusinessSolution.INSPECTIONS:
        return this._inspectionBookStrategyService;
      case EBusinessSolution.LAB_TESTING:
        return this._labTestingBookStrategyService;
      case EBusinessSolution.FOOD_CERTIFICATION:
      case EBusinessSolution.WQS:
        return this._foodCertificationBookStrategyService;
      case EBusinessSolution.AUDITS:
        return this._auditsBookStrategyService;
      default:
        return this._inspectionBookStrategyService;
    }
  }
}
